<template><div><h1>VUX V2.8.0 released</h1>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[fix] fix hard to move cursor</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[change] remove empty root div #2371</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[fix] fix not show clear button when initial value is zero #2482</li>
</ul>
<h2><a href="/en/components/x-number.html">XNumber</a></h2>
<ul><li>[fix] fix on-change fires after created</li>
</ul>
<h2><a href="/en/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[feature] add prop:disabled #2522</li>
</ul>
<h2><a href="/en/components/cookie.html">Cookie</a></h2>
<ul><li>[feature] 统一为es6 module格式</li>
</ul>
<h2><a href="/en/components/date.html">Date</a></h2>
<ul><li>[feature] 统一为es6 module格式</li>
</ul>
<h2><a href="/en/components/number.html">Number</a></h2>
<ul><li>[feature] 统一为es6 module格式</li>
</ul>
<h2><a href="/en/components/wechat.html">Wechat</a></h2>
<ul><li>[feature] upgrade to 1.3.2 #2396</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.8.0 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.8.0-139.vue?43527764